export const LOGOUT = 'app/LOGOUT'
export const SET_AUTH_TOKEN = 'app/SET_AUTH_TOKEN'
export const SET_URL = 'app/SET_URL'
export const SET_LANG = 'app/SET_LANG'
export const SET_REGION = 'app/SET_REGION'
export const SET_LOCATION = 'app/SET_LOCATION'
export const SET_REDIRECT = 'app/SET_REDIRECT'

export const LOCAL_USER_GEO = 'user_geo'